<template>
  <div class="statement-form">
    <el-form
      label-width="auto"
      :rules="rules"
      ref="statementForm"
      :model="statementForm"
      label-position="left"
    >
      <div class="form-title">
        <h3>会议需求</h3>
      </div>
      <div class="form-row">
        <el-form-item label="服务类别：" prop="service_type" class="form-item">
          <!-- <el-input v-model="statementForm.service_type" clearable></el-input> -->
          <el-select
            v-model="statementForm.service_type"
            @focus="loadCargosOptions()"
            @change="loadCargosOptions(statementForm.service_type)"
            filterable
            placeholder="请选择服务类别"
          >
            <el-option
              v-for="item in serviceTypeOpts"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务代码：" prop="service_code" class="form-item">
          <!-- <el-input v-model="statementForm.service_code" clearable></el-input> -->

          <el-select
            v-model="serviceCodeIdx"
            @change="serviceCodeChange"
            filterable
            placeholder="请选择服务代码"
          >
            <el-option
              v-for="(item, idx) in serviceCodeOpts"
              :key="idx"
              :label="item.service_code + ' / ' + item.service_desc"
              :value="idx"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务描述：" prop="service_desc" class="form-item">
          <el-input v-model="statementForm.service_desc" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="service_remark" class="form-item">
          <el-input v-model="statementForm.service_remark"></el-input>
        </el-form-item>
      </div>

      <div class="form-title">
        <h3>结算报价</h3>
      </div>
      <div class="form-row">
        <el-form-item label="数量：" prop="settlement_count" class="form-item">
          <el-input-number
            v-model="statementForm.settlement_count"
            clearable
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="单位：" prop="settlement_unit" class="form-item">
          <el-input v-model="statementForm.settlement_unit" clearable></el-input>
        </el-form-item>
        <el-form-item label="单价：" prop="settlement_unit_price" class="form-item">
          <el-input-number
            v-model="statementForm.settlement_unit_price"
            clearable
            :precision="2"
            :step="0.2"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="账期：" prop="settlement_pay_days" class="form-item">
          <el-input-number
            class="pay-days"
            v-model="statementForm.settlement_pay_days"
            :controls="false"
            clearable
            :min="0"
            @change="settlementPayDaysChange"
          ></el-input-number>
          <font class="pay-days-uint">天</font>
        </el-form-item>
        <el-form-item label="到期日：" prop="settlement_expire_date" class="form-item">
          <el-date-picker
            v-model="statementForm.settlement_expire_date"
            type="date"
            value-format="yyyy-MM-dd"
            disabled
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否计算服务费：" class="form-item">
          <el-switch v-model="statementForm.settlement_is_caculate" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item class="form-item">
          <el-upload
            class="upload-demo"
            :action="host + '/api/affix/uploader?file_type=' + 'settlement'"
            :before-remove="beforeRemove"
            multiple
            name="fname"
            :limit="1"
            :on-exceed="handleExceed"
            :on-remove="handlerSettlementRemove"
            :http-request="uploadFiles"
            :on-preview="handlePreview"
            :file-list="settlementFileList"
          >
            <el-button size="mini" type="primary" plain>上传附件</el-button>
          </el-upload>
        </el-form-item>
      </div>

      <div class="form-title">
        <h3>费用明细</h3>
      </div>
      <div class="form-row">
        <el-form-item label="现金：" prop="cost_cash" class="form-item">
          <el-input-number
            v-model="statementForm.cost_cash"
            clearable
            :precision="2"
            :step="0.2"
            :min="0"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="公务卡：" prop="cost_bussiness_card" class="form-item">
          <el-input-number
            v-model="statementForm.cost_bussiness_card"
            :precision="2"
            :step="0.2"
            clearable
            :min="0"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="备注：" prop="cost_remark" class="form-item">
          <el-input v-model="statementForm.cost_remark" clearable></el-input>
        </el-form-item>

        <el-form-item class="form-item">
          <el-upload
            class="upload-demo"
            :action="host + '/api/affix/uploader?file_type=' + 'cost'"
            :before-remove="beforeRemove"
            multiple
            name="fname"
            :limit="1"
            :on-remove="handlerCostRemove"
            :on-exceed="handleExceed"
            :http-request="uploadFiles"
            :file-list="costFileList"
            :on-preview="handlePreview"
          >
            <el-button size="small" type="primary" plain>上传附件</el-button>
          </el-upload>
        </el-form-item>
      </div>
      <div class="form-title">
        <h3>计调明细</h3>
      </div>

      <div class="form-row">
        <el-form-item label="数量：" prop="gauge_detail_count" class="form-item">
          <el-input-number
            v-model="statementForm.gauge_detail_count"
            clearable
            :min="0"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="单价：" prop="gauge_detail_unit_price" class="form-item">
          <el-input-number
            v-model="statementForm.gauge_detail_unit_price"
            clearable
            :precision="2"
            :step="0.2"
            :min="0"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="备注(供应商)：" prop="gauge_detail_remark" class="form-item">
          <!-- <el-input v-model="statementForm.gauge_detail_remark" clearable></el-input> -->

          <el-select
            v-model="statementForm.gauge_detail_remark"
            @focus="loadSuppliersOptions"
            @change="changeSuppliersOptions"
            filterable
            placeholder="请选择供应商"
            allow-create
          >
            <el-option
              v-for="item in supplierOptions"
              :key="item.supplier"
              :label="item.supplier"
              :value="item.supplier"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账期：" prop="gauge_pay_days" class="form-item">
          <el-input-number
            class="pay-days"
            v-model="statementForm.gauge_pay_days"
            clearable
            :controls="false"
            :min="0"
            @change="gaugePayDaysChange"
          ></el-input-number>
          <font class="pay-days-uint">天</font>
        </el-form-item>
        <el-form-item label="到期日：" prop="gauge_expire_date" class="form-item">
          <el-date-picker
            v-model="statementForm.gauge_expire_date"
            type="date"
            value-format="yyyy-MM-dd"
            disabled
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="form-item">
          <el-upload
            class="upload-demo"
            :action="host + '/api/affix/uploader?file_type=' + 'gauge'"
            :before-remove="beforeRemove"
            multiple
            name="fname"
            :limit="1"
            :on-remove="handlerGaugeRemove"
            :on-exceed="handleExceed"
            :http-request="uploadFiles"
            :file-list="gaugeFileList"
            :on-preview="handlePreview"
          >
            <el-button size="small" type="primary" plain>上传附件</el-button>
          </el-upload>
        </el-form-item>
      </div>

      <div class="form-btn-bottom">
        <el-button type="primary" @click="createListInfo" v-if="!statementForm.list_id"
          >立即创建</el-button
        >
        <el-button type="primary" @click="updateListInfo" v-else>立即修改</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </div>
    </el-form>
    <div style="margin-top: 25px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      settlementFileList: [],
      costFileList: [],
      gaugeFileList: [],
      meet_date: null,
      supplierOptions: [],
      serviceCodeIdx: null,
      serviceCodeOpts: [],
      serviceTypeOpts: [],
      statementForm: {
        list_id: null,
        service_type: "",
        service_code: "",
        service_desc: "",
        service_remark: "",
        settlement_count: 0,
        settlement_unit: "",
        settlement_unit_price: 0.0,
        settlement_pay_days: 0,
        settlement_expire_date: null,
        settlement_affix: "",
        settlement_is_caculate: true,
        cost_cash: 0.0,
        cost_bussiness_card: 0.0,
        cost_remark: "",
        cost_affix: "",
        gauge_detail_count: 0,
        gauge_detail_unit_price: 0.0,
        gauge_detail_remark: "",
        gauge_pay_days: 0,
        gauge_expire_date: null,
        gauge_affix: "",
      },
      rules: {
        service_type: [{ required: true, message: "请输入服务类别", trigger: "blur" }],
        service_code: [{ required: true, message: "请输入服务代码", trigger: "blur" }],
        service_desc: [{ required: true, message: "请输入服务描述", trigger: "blur" }],
      },
      project_id: null,
    };
  },
  methods: {
    handlerCostRemove(file, fileList) {
      let that = this;
      that.costFileList = [];
    },
    handlerGaugeRemove(file, fileList) {
      let that = this;
      that.gaugeFileList = [];
    },
    handlerSettlementRemove(file, fileList) {
      let that = this;
      that.settlementFileList = [];
    },
    handlePreview(file) {
      let that = this;
      that.$axios
        .get(file.url, {
          responseType: "blob",
          headers: { "Cache-Control": "no-cache" },
        })
        .then((res) => {
          let blob = new Blob([res.data]);
          let link = document.createElement("a");
          link.download = file.name;
          link.href = URL.createObjectURL(blob);
          link.click();
          URL.revokeObjectURL(link.href);
        });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    uploadFiles(params) {
      let that = this;
      let fileObj = params.file;
      let action = params.action;
      let form = new FormData();
      // 文件对象
      form.append("fname", fileObj);
      that.$axios
        .post(action, form, { headers: { "Content-Type": "multipart/form-data" } })
        .then((res) => {
          let results = res.data.results;
          if (results.file_type === "settlement") {
            that.settlementFileList = [];
            that.settlementFileList.push({
              name: results.file_name,
              url: that.host + results.file_url,
            });
          } else if (results.file_type == "cost") {
            that.costFileList = [];
            that.costFileList.push({
              name: results.file_name,
              url: that.host + results.file_url,
            });
          } else {
            that.gaugeFileList = [];
            that.gaugeFileList.push({
              name: results.file_name,
              url: that.host + results.file_url,
            });
          }
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    handleExceed(files, fileList) {
      let that = this;
      that.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    updateListInfo() {
      // 修改清单信息
      let that = this;
      that.statementForm.project_id = parseInt(that.project_id);
      if (that.settlementFileList.length > 0) {
        that.statementForm.settlement_affix = that.settlementFileList[0].name;
      } else {
        that.statementForm.settlement_affix = "";
      }
      if (that.costFileList.length > 0) {
        that.statementForm.cost_affix = that.costFileList[0].name;
      } else {
        that.statementForm.cost_affix = "";
      }
      if (that.gaugeFileList.length > 0) {
        that.statementForm.gauge_affix = that.gaugeFileList[0].name;
      } else {
        that.statementForm.gauge_affix = "";
      }
      that.$axios
        .put(that.host + "/api/lists", that.statementForm)
        .then((res) => {
          that.$message.success("修改成功");
          that.$router.push({
            path: "/statement/list",
            query: {
              project_id: that.project_id,
            },
          });
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    dateAddDays(dataStr, dayCount) {
      var strdate = dataStr;
      strdate = strdate.replace("-", "/");
      strdate = strdate.replace("-", "/");
      strdate = strdate.replace("-", "/");
      var isdate = new Date(strdate);
      isdate = new Date((isdate / 1000 + 86400 * dayCount) * 1000);
      var year = isdate.getFullYear(); // yyyy
      var month = isdate.getMonth() + 1; // M
      var day = isdate.getDate(); // d

      if (month >= 1 && month <= 9) {
        // MM
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        // dd
        day = "0" + day;
      }
      var pdate = year + "-" + month + "-" + day;
      return pdate;
    },
    settlementPayDaysChange() {
      let that = this;
      that.statementForm.settlement_expire_date = that.dateAddDays(
        that.meet_date,
        that.statementForm.settlement_pay_days
      );
    },
    gaugePayDaysChange() {
      let that = this;
      that.statementForm.gauge_expire_date = that.dateAddDays(
        that.meet_date,
        that.statementForm.gauge_pay_days
      );
    },
    loadSuppliersOptions() {
      let that = this;
      that.$axios
        .get(that.host + "/api/suppliers/options")
        .then((res) => {
          that.supplierOptions = res.data.results;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    changeSuppliersOptions() {
      let that = this;
      for (let i = 0; i < that.supplierOptions.length; i++) {
        let item = that.supplierOptions[i];
        if (item.supplier === that.statementForm.gauge_detail_remark) {
          that.statementForm.gauge_pay_days = item.pay_days;
        }
      }
    },
    serviceCodeChange() {
      let that = this;
      that.statementForm.service_code =
        that.serviceCodeOpts[this.serviceCodeIdx].service_code;
      that.statementForm.service_desc =
        that.serviceCodeOpts[this.serviceCodeIdx].service_desc;
      that.statementForm.service_remark =
        that.serviceCodeOpts[this.serviceCodeIdx].service_remark;
    },
    loadCargosOptions(serviceType) {
      let that = this;
      return new Promise((resolve, reject) => {
        if (!serviceType) {
          that.$axios
            .get(that.host + "/api/cargos/options")
            .then((res) => {
              that.serviceTypeOpts = res.data.results;
              resolve();
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
              reject;
            });
        } else {
          that.statementForm.service_code = "";
          that.statementForm.service_desc = "";
          that.statementForm.service_remark = "";
          that.serviceCodeIdx = null;
          that.$axios
            .get(that.host + "/api/cargos/options?service_type=" + serviceType)
            .then((res) => {
              that.serviceCodeOpts = res.data.results;
              resolve();
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
              reject;
            });
        }
      });
    },
    createListInfo() {
      let that = this;
      that.$refs["statementForm"].validate((valid) => {
        if (valid) {
          that.statementForm.project_id = parseInt(that.project_id);
          if (that.settlementFileList.length > 0) {
            that.statementForm.settlement_affix = that.settlementFileList[0].name;
          } else {
            that.statementForm.settlement_affix = "";
          }
          if (that.costFileList.length > 0) {
            that.statementForm.cost_affix = that.costFileList[0].name;
          } else {
            that.statementForm.cost_affix = "";
          }
          if (that.gaugeFileList.length > 0) {
            that.statementForm.gauge_affix = that.gaugeFileList[0].name;
          } else {
            that.statementForm.gauge_affix = "";
          }
          that.$axios
            .post(that.host + "/api/lists", that.statementForm)
            .then((res) => {
              that.$message.success("添加结算清单信息成功");
              that.$router.push({
                path: "/statement/list",
                query: {
                  project_id: that.project_id,
                },
              });
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        } else {
          that.$message.warning("参数验证不通过");
        }
      });
    },
    loadListDetail() {
      let that = this;
      that.$axios
        .get(
          that.host +
            "/api/lists?project_id=" +
            that.project_id +
            "&list_id=" +
            that.statementForm.list_id
        )
        .then((res) => {
          let results = res.data.results;
          // 加载cargos options
          that.loadCargosOptions(results.meet_demand.service_type).then((_) => {
            for (let i = 0; i < that.serviceCodeOpts.length; i++) {
              if (
                that.serviceCodeOpts[i].service_code == results.meet_demand.service_code
              ) {
                that.serviceCodeIdx = i;
              }
            }
          });
          if (results.settlement.affix !== "") {
            that.settlementFileList.push({
              name: results.settlement.affix,
              url: that.host + "/files/" + results.settlement.affix,
            });
          }
          if (results.cost_detail.affix !== "") {
            that.costFileList.push({
              name: results.cost_detail.affix,
              url: that.host + "/files/" + results.cost_detail.affix,
            });
          }
          if (results.gauge_detail.affix !== "") {
            that.gaugeFileList.push({
              name: results.gauge_detail.affix,
              url: that.host + "/files/" + results.gauge_detail.affix,
            });
          }
          that.statementForm = {
            list_id: results.list_id,
            service_type: results.meet_demand.service_type,
            service_code: results.meet_demand.service_code,
            service_desc: results.meet_demand.service_desc,
            service_remark: results.meet_demand.service_remark,
            settlement_count: results.settlement.count,
            settlement_unit: results.settlement.unit,
            settlement_unit_price: results.settlement.unit_price,
            settlement_pay_days: results.settlement.pay_days,
            settlement_expire_date: that.dateAddDays(
              that.meet_date,
              results.settlement.pay_days
            ),
            settlement_affix: results.settlement.affix,
            settlement_is_caculate: results.settlement.is_caculate, 
            cost_cash: results.cost_detail.cash,
            cost_bussiness_card: results.cost_detail.business_card,
            cost_remark: results.cost_detail.remark,
            cost_affix: results.cost_detail.affix,
            gauge_detail_count: results.gauge_detail.count,
            gauge_detail_unit_price: results.gauge_detail.unit_price,
            gauge_detail_remark: results.gauge_detail.remark,
            gauge_pay_days: results.gauge_detail.pay_days,
            gauge_expire_date: that.dateAddDays(
              that.meet_date,
              results.gauge_detail.pay_days
            ),
            gauge_affix: results.gauge_detail.affix,
          };
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
  },
  mounted() {
    let that = this;
    let project_id = that.$route.query.project_id;
    if (!project_id) {
      that.$router.go(-1);
      return;
    }
    that.project_id = project_id;
    let meet_time = that.$route.query.meet_time.split(" ");
    that.meet_date = meet_time[0];
    let list_id = that.$route.query.list_id;
    if (list_id) {
      that.statementForm.list_id = list_id;
      that.loadListDetail();
    }
  },
};
</script>

<style>
/* .el-upload-list__item-name {
  cursor: pointer;
} */
.pay-days-uint {
  margin-left: 5px;
}
.pay-days {
  width: 65px;
}
.statement-form {
  padding: 0 30px 0 30px;
}
.form-row {
  display: inline-block;
  margin: 5px 0 35px 0;
}
.form-title {
  margin: 0 0 25px 0;
}
.form-item {
  float: left;
  margin-right: 25px;
}
.form-btn-bottom {
  margin-top: 25px;
}
</style>
